module.exports = __webpack_public_path__ + "img/image_37.0fb1d236.png";